import React from 'react';
import Header from '../component/Header'
import SubBanner from '../component/SubBanner'
import BlogList from '../component/BlogList'  
import Footer from '../component/Footer';
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import '../scss/blog.scss'; 


function Blog() {
  const { slug } = useParams();
  
  return (
    <>
      <Helmet>
        <title>Blogs | Helpotani</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>
      <main className='blog-page'>
      <Header />   
        <SubBanner HeaderTitle="Our Blogs" />    
        <BlogList categorySlug={slug} />
      </main>
      <Footer />
    </>
  )
}
export default Blog 


